import { useCallback, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../helpers';

export const useLegalClientRepresentativeSettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (id: string, currentStepName: OnboardingProcessStepNameType) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id,
          input,
        },
      });
      return res.data?.legalClientRepresentativeSettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.legalClientRepresentativeSettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    process: useMemo(
      () =>
        data?.legalClientRepresentativeSettingsSave?.process
          ? parseOnboardingProcessEntity(
              data?.legalClientRepresentativeSettingsSave?.process
            )
          : undefined,
      [data?.legalClientRepresentativeSettingsSave?.process]
    ),
    loading,
    error,
    saveSettings,
  };
};
